import { z } from 'zod';
export const createWorkspaceSchema = z.object({
    name: z.string().min(2).max(120).trim(),
    description: z.string().max(1000).trim().optional(),
});
export const updateWorkspaceSchema = createWorkspaceSchema.partial();
//# sourceMappingURL=workspace.contract.js.map